import { Component, OnInit, ViewChild, Inject, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SuppInvSearchSubitemComponent } from '../supp-inv-search-subitem/supp-inv-search-subitem.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-return-supplier-invoice-item',
  templateUrl: './return-supplier-invoice-item.component.html',
  styleUrls: ['./return-supplier-invoice-item.component.css']
})
export class ReturnSupplierInvoiceItemComponent implements OnInit {

  @Input('model') model: any;
  @Input('data_model') data_model: any;
  @Input('supplier_invoice_item') supplier_invoice_item: any;
  @Input('supplier_inv_model') supplier_inv_model: any;

  @Output() dpList = new EventEmitter<any>();

  count = 1;
  dp = [];
  displayedColumns = ['sub_item_no', 'sub_item_name', 'unit_name', 'price', 'count', 'discount', 'net_price',
    'return_count', 'return_net_total', 'comment'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  subItemDialogRef: MatDialogRef<SuppInvSearchSubitemComponent>;
  //taxList = [];
  //add_inv_item;
  item_count = 0;
  org_unit_id = 0;

  Ret_Count_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Ret_Count_Msg').subscribe((res: string) => {
      this.Ret_Count_Msg = res;
    });
  }

  ngOnInit() {
    this.dp = [{ 'id': this.count, 'available_count': '', 'unit_id': '' }];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  ngOnChanges() {
    // console.log(this.invoice_item);
    if (this.supplier_invoice_item != undefined && this.supplier_invoice_item.length > 0) {
      this.dp = [];
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;

      this.dp = this.supplier_invoice_item
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;

      this.item_count = this.supplier_invoice_item.length;
    }
  }

  changeCount(event) {
    let id = event.srcElement.id;
    let row_id = id.substring(id.lastIndexOf('_') + 1);
    let ret_count = Number(event.srcElement.value);
    let dp_index = this.getDPIndex(row_id);

    let qty = Number((document.getElementById('count_' + row_id) as HTMLInputElement).value);
    if (ret_count <= qty) {
      this.dp[dp_index]['return_count'] = ret_count;
      this.calculateTotal();

      // if (this.data_model['mode'] == 'edit')
      //   this.dp[dp_index]['flag'] = 'update';
    }
    else {
      (document.getElementById('return_count_' + row_id) as HTMLInputElement).value = this.dp[dp_index]['return_count'];
      alert(this.Ret_Count_Msg);

      // this.model['total'] = (Number(this.model['total']) - Number(this.dp[dp_index]['return_total_price'])).toFixed(2);
      // this.model['discount'] = (Number(this.model['discount']) - Number(this.dp[dp_index]['return_discount'])).toFixed(2);
      // this.model['tax'] = (Number(this.model['tax']) - Number(this.dp[dp_index]['return_tax'])).toFixed(2);
      // console.log('return_net_total: ' + Number(this.dp[dp_index]['return_net_total']));
      // console.log('final_total_ret : ' + Number(this.data_model['final_total_ret']));
      // this.data_model['final_total_ret'] = (Number(this.data_model['final_total_ret']) - Number(this.dp[dp_index]['return_net_total'])).toFixed(2);

      // this.dp[dp_index]['return_count'] = '0';
      // (document.getElementById('return_count_' + row_id) as HTMLInputElement).value = this.dp[dp_index]['return_count'];
      // this.dp[dp_index]['return_total_price'] = '0';
      // this.dp[dp_index]['return_discount'] = '0';
      // this.dp[dp_index]['return_tax'] = '0';
      // this.dp[dp_index]['return_net_total'] = '0';
      // (document.getElementById('return_net_total_' + row_id) as HTMLInputElement).value = this.dp[dp_index]['return_net_total'];

      // this.model['total'] = (Number(this.model['total']) - Number((document.getElementById('return_total_' + row_id) as HTMLInputElement).value)).toFixed(2);
      // this.model['tax'] = (Number(this.model['tax']) - Number((document.getElementById('return_tax_' + row_id) as HTMLInputElement).value)).toFixed(2);
      // this.data_model['final_total_ret'] = (Number(this.data_model['final_total_ret']) - Number((document.getElementById('return_total_' + row_id) as HTMLInputElement).value)).toFixed(2);

      // (document.getElementById('return_count_' + row_id) as HTMLInputElement).value = '0';
      // (document.getElementById('return_total_' + row_id) as HTMLInputElement).value = '0';
      // (document.getElementById('return_tax_' + row_id) as HTMLInputElement).value = '0';

      // this.calculateTotal(row_id);
    }
  }

  calculateTotal() {
    let total = 0, discount = 0, tax = 0;
    this.dp.forEach(element => {
      element.return_total_price = Number(element.return_count) * Number(element.price);
      element.return_discount = Number(element.return_count) * Number(element.unit_discount);
      element.return_tax = Number(element.return_count) * Number(element.unit_tax);
      element.return_net_total = (element.return_total_price - 
        element.return_discount + element.return_tax).toFixed(2);

      total += element.return_total_price;
      discount += element.return_discount;
      tax += element.return_tax;
    });
    this.model['total'] = total.toFixed(2);
    this.model['discount'] = discount.toFixed(2);
    this.model['tax'] = tax.toFixed(2);
    this.data_model['final_total_ret'] = (total - discount + tax).toFixed(2);
    
    // let dp_index = this.getDPIndex(row_id);

    // let price = Number(this.dp[dp_index]['price']);
    // let return_count = Number((document.getElementById('return_count_' + row_id) as HTMLInputElement).value);
    // let org_total_price = Number(this.dp[dp_index]['return_total_price']);
    // let org_discount = Number(this.dp[dp_index]['return_discount']);
    // let org_tax_amount = Number(this.dp[dp_index]['return_tax']);
    // let org_net_total = Number(this.dp[dp_index]['return_net_total']);
    // console.log(org_discount);
    // this.dp[dp_index]['return_total_price'] = (price * return_count);
    // this.dp[dp_index]['return_discount'] = Number(this.dp[dp_index]['unit_discount']) * return_count;
    // this.dp[dp_index]['return_tax'] = Number(this.dp[dp_index]['unit_tax']) * return_count;
    // this.dp[dp_index]['return_net_total'] = (this.dp[dp_index]['return_total_price'] - this.dp[dp_index]['return_discount'] + this.dp[dp_index]['return_tax']).toFixed(2);
    // (document.getElementById('return_net_total_' + row_id) as HTMLInputElement).value = this.dp[dp_index]['return_net_total'];
    // console.log('org mode: ' + Number(this.model['discount']));
    // this.model['total'] = ((Number(this.model['total']) - org_total_price) + this.dp[dp_index]['return_total_price']).toFixed(2);
    // this.model['discount'] = ((Number(this.model['discount']) - org_discount) + this.dp[dp_index]['return_discount']).toFixed(2);
    // this.model['tax'] = ((Number(this.model['tax']) - org_tax_amount) + this.dp[dp_index]['return_tax']).toFixed(2);
    // this.data_model['final_total_ret'] = ((Number(this.data_model['final_total_ret']) - org_net_total) + Number(this.dp[dp_index]['return_net_total'])).toFixed(2);
    // console.log(this.model['discount']);
    // let price = Number((document.getElementById('price_' + row_id) as HTMLInputElement).value);
    // let return_count = Number((document.getElementById('return_count_' + row_id) as HTMLInputElement).value);
    // let org_total = Number((document.getElementById('ret_no_tax_total_' + row_id) as HTMLInputElement).value);
    // //console.log(org_total);
    // let org_return_total = Number((document.getElementById('return_total_' + row_id) as HTMLInputElement).value);
    // let return_total = (price * return_count);
    // //console.log(return_total);
    // (document.getElementById('ret_no_tax_total_' + row_id) as HTMLInputElement).value = return_total.toFixed(2);
    // let count = Number((document.getElementById('count_' + row_id) as HTMLInputElement).value);
    // let tax_amount1 = Number((document.getElementById('tax_amount_' + row_id) as HTMLInputElement).value);
    // let org_tax_amount = Number((document.getElementById('return_tax_' + row_id) as HTMLInputElement).value);
    // //console.log("org_tax_amount:"+org_tax_amount);
    // let ret_tax_amount = (tax_amount1 / count) * return_count;
    // //console.log("ret_tax_amount:"+ret_tax_amount);
    // (document.getElementById('return_tax_' + row_id) as HTMLInputElement).value = ret_tax_amount.toFixed(2);

    // let ret_net_price = (return_total + ret_tax_amount);

    // (document.getElementById('return_total_' + row_id) as HTMLInputElement).value = ret_net_price.toFixed(2);

    // this.model['total'] = ((Number(this.model['total']) - org_total) + return_total).toFixed(2);
    // this.model['tax'] = ((Number(this.model['tax']) - org_tax_amount) + ret_tax_amount).toFixed(2);
    // this.data_model['final_total_ret'] = ((Number(this.data_model['final_total_ret']) - org_return_total) + ret_net_price).toFixed(2);

    this.dpList.emit(this.dp);
    // this.voted.emit(agreed);
  }

  getDPIndex(row_id) {
    let index = 0
    for (index = 0; index < this.dp.length; index++) {
      let element = this.dp[index];
      if (element.id == row_id)
        break;
    }
    return index;
  }

  changeFlag(event) {
    if (this.data_model['mode'] == 'edit') {
      let id = event.srcElement.id;
      let row_id = id.substring(id.lastIndexOf('_') + 1);
      let dp_index = this.getDPIndex(row_id);
      this.dp[dp_index]['flag'] = 'update';
    }
  }

}
